import React from 'react';
import { useTranslation } from 'react-i18next';
import LiveRegion from '../../../../atoms/LiveRegion/LiveRegion';
import { InteractionStatus } from '../../../../../types/InteractionStatus';
import { FormUtils, useFormContext } from '../../../../molecules/Form';
import { Namespace } from '../../../../../translation/namespace';
import FormSelect, { optionsProcessor } from '../../../../molecules/Form/components/FormSelect/FormSelect';
import FormsRow from '../../../../molecules/Form/components/FormsRow/FormsRow';
import { FormSubmitButton } from '../../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';

type ConnectActionFormTemplateType = {
  actionType: 'connectBlocks';
};

export function ConnectActionFormTemplate({ actionType }: ConnectActionFormTemplateType) {
  const { t } = useTranslation('ContentWrapper');
  const { inputs, onChange, getStatus, submitActionEnabled } = useFormContext();

  const uniqueId = `${inputs.groupLayout.name}-connect-block`;

  const statusMessages = () => {
    return {
      [InteractionStatus.SENDING]: FormUtils.createStatusMessage(
        t(`actions.${actionType}.status.${InteractionStatus.SENDING}`),
      ),
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
        t(`actions.${actionType}.status.${InteractionStatus.SUCCESS}`),
      ),
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(
        t(`actions.${actionType}.status.${InteractionStatus.FAIL}`),
      ),
    };
  };

  return (
    <>
      <FormsRow>
        <FormSelect
          id={uniqueId}
          name={inputs.groupLayout.name}
          required={inputs.groupLayout.required}
          labelTitle={t(`actions.${actionType}.label`)}
          value={inputs.groupLayout.value}
          options={optionsProcessor(
            inputs.groupLayout.name,
            inputs.groupLayout.options as any,
            `${Namespace.ContentWrapper}:actions.${actionType}`,
          )}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => onChange(event.target.name, event.target.value)}
        />
      </FormsRow>
      <FormSubmitButton buttonLabel={t(`actions.${actionType}.saveButton`)} enabled={submitActionEnabled()} />
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic>
        {getStatus(statusMessages())}
      </LiveRegion>
    </>
  );
}
